import * as React from "react";
import { SimpleTemplate } from "@/templates/SimpleTemplate";
import { Header } from "@/components/atoms/Header";
import { useBrandingContext } from "@/contexts/BrandingContext";

export type OpenBankingDonePageProps = object;

export const OpenBankingDonePage: React.FC<OpenBankingDonePageProps> = () => {
  const { brand } = useBrandingContext();

  return (
    <SimpleTemplate headerType="logo">
      <Header level={1}>{brand} Account Search</Header>

      <p>
        Thank you. We will process this data and get back to you shortly. You may now close this
        window.
      </p>
    </SimpleTemplate>
  );
};
